import { gql } from '@apollo/client';

export const INSTRUCTOR_DELETE = gql`
    mutation deleteInstructor( $id: UUID! ) {
        deleteInstructor( id: $id ){
            success
            message
        }
    }
`;

export default INSTRUCTOR_DELETE;
